export function originHeaders(viewIsPaid) {
  let header = [
    {
      text: 'STT',
      value: 'stt',
      align: 'center',
      sortable: false,
      show: true,
      width: '4%',
    },
    {
      text: 'Học sinh',
      value: 'name',
      align: 'left',
      sortable: false,
      show: true,
      width: '24%',
    },
    {
      text: 'Ngày sinh',
      value: 'dob',
      align: 'left',
      sortable: false,
      show: true,
      width: '12%',
    },
    {
      text: 'Lớp',
      value: 'currentClass',
      align: 'left',
      sortable: false,
      show: true,
      width: '8%',
    },
    {
      text: 'Tổng số tiền thu',
      value: 'moneyTotal',
      align: 'left',
      sortable: false,
      show: true,
      width: '10%',
    },
    {
      text: 'Số tiền đã nộp',
      value: 'amountPaid',
      align: 'left',
      sortable: false,
      show: true,
      width: '10%',
    },
    {
      text: 'Còn nợ',
      value: 'amountDebt',
      align: 'left',
      sortable: false,
      show: true,
      width: '10%',
    },
    {
      text: 'Thao tác',
      value: 'action',
      align: 'center',
      sortable: false,
      show: true,
      width: '8%',
    },
  ]
  return header
}
export const headerExcel = [
  {
    text: 'Tên học sinh',
    value: 'name',
  },
  {
    text: 'Mã số',
    value: 'code',
  },
  {
    text: 'Lớp',
    value: 'class',
  },
  {
    text: 'Ghi chú',
    value: 'notes',
  },
  {
    text: 'Tổng số tiền thu',
    value: 'totalAmount',
  },
  {
    text: 'Tổng số tiền đã nộp',
    value: 'amountPaid',
  },
  {
    text: 'Số tiền còn nợ',
    value: 'amountDebt',
  },
]
